module.exports = __webpack_public_path__ + "static/media/wallet.444b3222.svg";